import React, { useState } from "react";
import "./BuilderSidebar.scss";

const ICONS = {
  Activities: (
    <img
      src="https://cdn.ninestatic.com/front/components/sidebar/png/missions.png"
      alt="Activities"
      width={40}
      height={40}
    />
  ),
  Casino: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
      <path
        d="M6.5 22c2.485 0 4.5-2.04 4.5-4.557a4.57 4.57 0 0 0-1.035-2.907c.848-.885 1.774-2.32 2.496-3.976.729-1.673 1.285-3.656 1.326-5.659q.267.189.531.468c.468.496.886 1.167 1.243 1.921.602 1.273.98 2.683 1.13 3.644C14.592 11.32 13 13.181 13 15.418c0 2.517 2.015 4.557 4.5 4.557s4.5-2.04 4.5-4.557c0-2.274-1.645-4.16-3.795-4.502-.151-1.128-.586-2.79-1.291-4.282-.398-.84-.898-1.664-1.51-2.314-.18-.19-.374-.37-.58-.531l.913-.309a.76.76 0 0 0 .475-.96.75.75 0 0 0-.949-.48l-4.5 1.518a.76.76 0 0 0-.474.96.75.75 0 0 0 .948.481l1.052-.355c.005 1.815-.495 3.684-1.2 5.303-.71 1.627-1.585 2.912-2.262 3.595a4.44 4.44 0 0 0-2.327-.656c-2.485 0-4.5 2.04-4.5 4.557S4.015 22 6.5 22"
        fill="currentColor"
      ></path>
    </svg>
  ),
  Live: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
      <path
        d="M6.343 4.938a1 1 0 0 1 0 1.415 8.003 8.003 0 0 0 0 11.317 1 1 0 1 1-1.415 1.414c-3.906-3.906-3.906-10.24 0-14.146a1 1 0 0 1 1.415 0m12.731 0c3.906 3.907 3.906 10.24 0 14.146a1 1 0 0 1-1.414-1.414 8.003 8.003 0 0 0 0-11.317 1 1 0 0 1 1.414-1.415M9.31 7.812a1 1 0 0 1 0 1.414 3.92 3.92 0 0 0 0 5.544 1 1 0 1 1-1.414 1.414 5.92 5.92 0 0 1 0-8.372 1 1 0 0 1 1.414 0m6.959 0a5.92 5.92 0 0 1 0 8.372 1 1 0 0 1-1.415-1.414 3.92 3.92 0 0 0 0-5.544 1 1 0 0 1 1.415-1.414m-4.187 2.77a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        fill="currentColor"
      ></path>
    </svg>
  ),
  Sports: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
      <path
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M8.244 4.373l3.008 1.8v2.193l-2.791 2.028-2.044-.707-.587-3.534a8.5 8.5 0 0 1 2.414-1.78m-4.623 9.066 2.327-2.327 2.04.705L9.07 15.15l-.97 1.575-3.293-.194a8.45 8.45 0 0 1-1.186-3.092m6.909 6.934-1.184-2.809.963-1.567h3.372l.912 1.581-1.04 2.78a8.6 8.6 0 0 1-3.023.015m8.362-3.397-3.024-.19-.938-1.624 1.087-3.345 2.013-.696 2.312 2.52a8.5 8.5 0 0 1-1.45 3.335m-.72-10.82-.589 3.533-2.04.705-2.791-2.028V6.172l3.002-1.8a8.5 8.5 0 0 1 2.418 1.784"
        fill="currentColor"
      ></path>
    </svg>
  ),
  Esports: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
      <path
        d="M22.883 10.467c-.289-1.225-.856-2.29-1.943-3.006-1.544-1.016-3.168-1.109-4.84-.296-.062.03-.142.068-.202.055-.306-.067-.607-.15-.922-.228.01-.05.013-.089.024-.127q.126-.444.25-.888c.144-.517.523-.744 1.057-.634.806.167 1.6-.156 1.985-.854.15-.274.22-.594.31-.898a.447.447 0 0 0-.317-.568c-.276-.08-.545.054-.627.315-.043.137-.09.274-.117.414-.108.56-.625.786-1.127.66a1.787 1.787 0 0 0-2.13 1.23l-.313 1.093c-.32-.08-.62-.15-.916-.232a.27.27 0 0 1-.136-.113 4.6 4.6 0 0 0-4.834-2.005c-1.54.33-2.695 1.213-3.498 2.512-.595.963-1.124 1.967-1.661 2.964a112 112 0 0 0-1.719 3.296c-.436.878-.16 1.97.608 2.595 1.006.82 2.552.843 3.64.064 1.09-.782 2.186-1.557 3.278-2.337a.28.28 0 0 1 .26-.049c.505.134 1.013.258 1.52.387q2.6.659 5.199 1.324c.069.018.154.075.181.136.537 1.178 1.059 2.363 1.601 3.54.503 1.089 1.372 1.7 2.597 1.777 1.21.077 2.276-.679 2.52-1.793.084-.383.09-.784.11-1.178.086-1.66.17-3.32.244-4.98.032-.726.088-1.455-.082-2.176m-12.327-.762c-.17.194-.394.244-.642.185-.325-.077-.648-.163-.993-.25-.093.325-.177.631-.268.935-.086.29-.333.454-.64.436a.6.6 0 0 1-.572-.503.8.8 0 0 1 .03-.302c.073-.283.157-.563.236-.845.003-.009-.001-.02-.004-.05q-.466-.12-.945-.24c-.224-.056-.387-.18-.463-.396a.5.5 0 0 1 .128-.553.68.68 0 0 1 .677-.186c.26.06.516.131.775.197.055.014.11.026.18.042.088-.31.17-.616.26-.92a.63.63 0 0 1 .61-.447c.275-.002.526.164.59.42a.75.75 0 0 1-.005.345c-.07.294-.16.584-.24.875-.003.01 0 .02.002.048l.931.237c.205.052.363.16.447.353a.55.55 0 0 1-.094.619m8.03-.642c.46.003.817.345.814.78-.003.437-.36.774-.822.774-.458 0-.824-.342-.825-.771-.002-.434.372-.785.834-.783m-2.474 1.606c.007-.42.385-.761.833-.75.463.013.826.36.807.792-.02.437-.318.784-.817.772-.471-.009-.83-.364-.823-.814m1.778 2.405c-.45 0-.824-.35-.83-.774-.004-.44.368-.792.842-.794.406-.003.796.396.797.816.002.41-.366.752-.81.752m1.656-.897c-.453-.002-.821-.354-.82-.781.003-.41.375-.806.772-.774.46.036.837.325.856.82.015.39-.378.738-.808.735"
        fill="currentColor"
      ></path>
    </svg>
  ),
  Support: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
      <path
        d="M12 3C6.477 3 2 7.477 2 13v3a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5v-1c0-4.418 3.582-8 8-8s8 3.582 8 8v1h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a3 3 0 0 0 3-3v-3c0-5.523-4.477-10-10-10z"
        stroke="#09e41f"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="4"
        y="15"
        width="3"
        height="4"
        rx="1"
        fill="#161d37"
        stroke="#09e41f"
        strokeWidth="2"
      />
      <rect
        x="17"
        y="15"
        width="3"
        height="4"
        rx="1"
        fill="#161d37"
        stroke="#09e41f"
        strokeWidth="2"
      />
    </svg>
  ),
};

const Divider = () => <div className="builder-sidebar-divider my-2" />;

const ICON_LABELS = [
  "Activities",
  "Casino",
  "Live casino",
  "Sports",
  "Esports",
  "Support",
];

const BuilderSidebar = () => {
  const [hovered, setHovered] = useState(null);
  return (
    <div className="builder-sidebar d-flex flex-column p-2">
      {/* Top icon button */}
      <div className="mb-2 position-relative">
        <button
          className="builder-sidebar-btn d-flex align-items-center justify-content-center w-100 bg-transparent p-1 rounded-2"
          onMouseEnter={() => setHovered(0)}
          onMouseLeave={() => setHovered(null)}
        >
          {ICONS.Activities}
          {hovered === 0 && <div className="sidebar-tooltip">Activities</div>}
        </button>
      </div>
      <Divider />
      {/* Menu icons */}
      <div className="mb-1 d-flex flex-column align-items-center">
        <div className="mb-1 position-relative">
          <a
            href="#"
            className="builder-sidebar-icon d-flex align-items-center justify-content-center rounded-2 mb-1"
            onMouseEnter={() => setHovered(1)}
            onMouseLeave={() => setHovered(null)}
          >
            {ICONS.Casino}
            {hovered === 1 && <div className="sidebar-tooltip">Casino</div>}
          </a>
        </div>
        <div className="mb-1 position-relative">
          <a
            href="#"
            className="builder-sidebar-icon d-flex align-items-center justify-content-center rounded-2 mb-1"
            onMouseEnter={() => setHovered(2)}
            onMouseLeave={() => setHovered(null)}
          >
            {ICONS.Live}
            {hovered === 2 && (
              <div className="sidebar-tooltip">Live casino</div>
            )}
          </a>
        </div>
        <div className="mb-1 position-relative">
          <a
            href="#"
            className="builder-sidebar-icon d-flex align-items-center justify-content-center rounded-2 mb-1"
            onMouseEnter={() => setHovered(3)}
            onMouseLeave={() => setHovered(null)}
          >
            {ICONS.Sports}
            {hovered === 3 && <div className="sidebar-tooltip">Sports</div>}
          </a>
        </div>
        <div className="mb-1 position-relative">
          <a
            href="#"
            className="builder-sidebar-icon d-flex align-items-center justify-content-center rounded-2 mb-1"
            onMouseEnter={() => setHovered(4)}
            onMouseLeave={() => setHovered(null)}
          >
            {ICONS.Esports}
            {hovered === 4 && <div className="sidebar-tooltip">Esports</div>}
          </a>
        </div>
      </div>
      <Divider />
      {/* Headphone icon at the very bottom */}
      <div className="mb-1 d-flex flex-column align-items-center position-relative">
        <button
          className="builder-sidebar-headphone-btn d-flex align-items-center justify-content-center w-100 bg-transparent p-1 rounded-2"
          onMouseEnter={() => setHovered(5)}
          onMouseLeave={() => setHovered(null)}
        >
          {ICONS.Support}
          {hovered === 5 && <div className="sidebar-tooltip">Support</div>}
        </button>
      </div>
    </div>
  );
};

export default BuilderSidebar;
export { ICONS };

